import { render, staticRenderFns } from "./Decorations.vue?vue&type=template&id=a9e78ce8&scoped=true"
import script from "./Decorations.vue?vue&type=script&lang=js"
export * from "./Decorations.vue?vue&type=script&lang=js"
import style0 from "./Decorations.vue?vue&type=style&index=0&id=a9e78ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e78ce8",
  null
  
)

export default component.exports